/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { GalaxyParent, ColonyParent } from 'solis/rpc/parent';

import * as Upcast from 'solis/rpc/upcast';


export const createColonyRoutes = (routes) =>
{
  routes.createDetach('galaxy/colonies/:id', (application, { id }) =>
  {
    application.getGalaxy()?.unloadColony({ id })
  });

  routes.createRecord('galaxy/colonies/:id/cass', {
    parent: GalaxyParent,
    load:   (galaxy, cass)   => galaxy.loadColony(cass),
    unload: (galaxy, { id }) => galaxy.unloadColony({ id }),
  });

  routes.createTable('galaxy/colonies/:colony/sectors', {
    parent: ColonyParent,
    upcast: [ Upcast.Transform ],
    load:   (colony, cass) => colony.loadSector(cass),
    unload: (colony, cass) => colony.unloadSector(cass),
    values: (colony) => colony.getSectors().values(),
  });

  routes.createTable('galaxy/colonies/:colony/zones', {
    parent: ColonyParent,
    upcast: [ Upcast.HexID ],
    key:    (cass) => `${cass.sector}:${cass.id}`,
    load:   (colony, cass) => colony.loadZone(cass),
    unload: (colony, cass) => colony.unloadZone(cass),
    values: (colony) => colony.getZones().values(),
  });
};
